import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { getSettings, updateSettings as dbUpdateSettings, DEFAULT_SETTINGS } from '../db';
import { ensureBaseData, seedDemoData } from '../utils/seed';

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      const s = await getSettings();
      if (!s.demoDataLoaded) {
        await seedDemoData();
      } else {
        await ensureBaseData();
      }
      const fresh = await getSettings();
      setSettings(fresh);
      setReady(true);
    })().catch(e => setError(e.message));
  }, []);

  const update = useCallback(async (patch) => {
    const merged = await dbUpdateSettings(patch);
    setSettings(merged);
    return merged;
  }, []);

  const refresh = useCallback(async () => {
    const s = await getSettings();
    setSettings(s);
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, update, refresh, ready, error }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
